import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Typography,
  makeStyles,
} from '@material-ui/core';
import { Inbox as InboxIcon } from '@material-ui/icons';

import { getBrand } from 'theme/brand';
import PINPEO from 'theme/palette';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${PINPEO.border}`,
    borderRadius: PINPEO.radiusCard,
    padding: theme.spacing(8, 3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: getBrand().primarySoft,
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: theme.spacing(1),
    '& svg': {
      fontSize: 26,
    },
  },
  title: {
    fontSize: 15,
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  description: {
    fontSize: 13,
    color: theme.palette.text.secondary,
    maxWidth: 360,
    lineHeight: 1.6,
  },
  action: {
    marginTop: theme.spacing(2),
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 13,
    borderRadius: PINPEO.radius,
    borderColor: PINPEO.borderStrong,
    '&:hover': {
      borderColor: theme.palette.primary.main,
      color: theme.palette.primary.main,
      backgroundColor: PINPEO.rowHover,
    },
  },
}));

/**
 * Estado vacío consistente (§3.3 de la guía visual).
 * Solo presentación: la acción se recibe por props desde la vista.
 */
function EmptyState(props) {
  const {
    action,
    description,
    icon: Icon,
    title,
  } = props;
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.icon}>
        {Icon ? <Icon /> : <InboxIcon />}
      </Box>
      <Typography className={classes.title}>{title}</Typography>
      {description && (
        <Typography className={classes.description}>{description}</Typography>
      )}
      {action && (
        <Button
          children={action.label}
          className={classes.action}
          onClick={action.fn}
          startIcon={action.icon}
          variant="outlined"
        />
      )}
    </Box>
  );
}

EmptyState.defaultProps = {
  description: '',
};

EmptyState.propTypes = {
  action: PropTypes.shape({
    fn: PropTypes.func,
    icon: PropTypes.element,
    label: PropTypes.string,
  }),
  description: PropTypes.string,
  icon: PropTypes.any,
  title: PropTypes.string.isRequired,
};

export default EmptyState;
